module.exports = __webpack_public_path__ + "img/background6.bc765886.png";